import OspreyContentBlocksGetById from './content-blocks-get-by-id'
import OspreyContentBlocksGetThumbnails from './content-blocks-get-thumbnails'
import OsperyContentBlocksMetadata from './content-blocks-metadata'
import OspreyContentBlocksSearch from './content-blocks-search'
import OspreyContentBlocksSearchSuggestion from './content-blocks-search-suggestion'
import OspreyContentBlocksTagsApply from './content-blocks-tags-apply'
import OspreyContentBlocksTagsRemove from './content-blocks-tags-remove'

export default class ContentBlocks {

    search(dataKey) {
        return new OspreyContentBlocksSearch(dataKey)
    }

    getSearchSuggestion(dataKey) {
        return new OspreyContentBlocksSearchSuggestion(dataKey)
    }

    getMetadata() {
        return new OsperyContentBlocksMetadata()
    }

    getById(dataKey) {
        return new OspreyContentBlocksGetById(dataKey)
    }

    getThumbnails(dataKey) {
        return new OspreyContentBlocksGetThumbnails(dataKey)
    }

    applyTagToContentBlock(dataKey) {
        return new OspreyContentBlocksTagsApply(dataKey)
    }

    removeTagFromContentBlock(dataKey) {
        return new OspreyContentBlocksTagsRemove(dataKey)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/content-blocks/index.js